import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import api from "services/api";
import { requireAuth } from "actions/AuthAction";
import { resolveUploadUrl } from "utils";
import { useSiteAssets } from "context/SiteAssetsContext";
import { SITE_ASSET_FALLBACKS } from "utils/siteAssets";
import AsetGambarFormDialog from "./components/AsetGambarFormDialog";

function AdminAsetGambar() {
  const navigate = useNavigate();
  const { reloadAssets } = useSiteAssets();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [formOpen, setFormOpen] = useState(false);

  const loadData = useCallback(() => {
    setLoading(true);
    api
      .get("aset-gambar")
      .then((res) => setRows(res.data?.data || []))
      .catch((error) => {
        const status = error.response?.status;
        alert(`Gagal memuat aset gambar${status ? ` (status ${status})` : ""}. Pastikan backend sudah di-restart.`);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (!requireAuth(navigate, ["ADMIN", "SUPER_ADMIN"])) return undefined;
    loadData();
    return undefined;
  }, [navigate, loadData]);

  const openEdit = (item) => {
    setSelectedItem(item);
    setFormOpen(true);
  };

  const handleSaved = () => {
    loadData();
    reloadAssets();
  };

  const getPreviewUrl = (item) => {
    if (item.file_url) return resolveUploadUrl(item.file_url);
    return SITE_ASSET_FALLBACKS[item.kode] || "";
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox mb={3}>
          <MDTypography variant="h4" fontWeight="medium">
            Aset Gambar Sistem
          </MDTypography>
          <MDTypography variant="button" color="text">
            Kelola logo dan background yang dipakai di landing page, login, registrasi, dan verifikasi.
            Untuk foto kegiatan dinas, gunakan menu Galeri Aktivitas.
          </MDTypography>
        </MDBox>

        {loading ? (
          <MDTypography>Memuat...</MDTypography>
        ) : (
          <Grid container spacing={3}>
            {rows.map((item) => (
              <Grid item xs={12} sm={6} lg={4} key={item.kode}>
                <Card sx={{ height: "100%" }}>
                  <CardMedia
                    component="img"
                    height="180"
                    image={getPreviewUrl(item)}
                    alt={item.nama}
                    sx={{ objectFit: "cover", backgroundColor: "#f5f5f5" }}
                  />
                  <CardContent>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                      <MDTypography variant="button" fontWeight="bold">
                        {item.nama}
                      </MDTypography>
                      <Chip
                        label={item.file_path ? "Custom" : "Default"}
                        size="small"
                        color={item.file_path ? "info" : "default"}
                      />
                    </MDBox>
                    <MDTypography variant="caption" color="text" display="block" mb={0.5}>
                      Kode: {item.kode}
                    </MDTypography>
                    <MDTypography variant="caption" color="text" display="block" mb={1}>
                      {item.halaman}
                    </MDTypography>
                    <MDTypography variant="body2" color="text" mb={2}>
                      {item.deskripsi}
                    </MDTypography>
                    <MDButton size="small" variant="outlined" color="info" onClick={() => openEdit(item)}>
                      Ubah / Ganti Foto
                    </MDButton>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </MDBox>
      <Footer />

      <AsetGambarFormDialog
        open={formOpen}
        item={selectedItem}
        onClose={() => setFormOpen(false)}
        onSaved={handleSaved}
      />
    </DashboardLayout>
  );
}

export default AdminAsetGambar;
